import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme.js';
import Nav from './components/Nav.jsx';
import Hero from './components/Hero.jsx';
import Products from './components/Products.jsx';
import CompanyStory from './components/CompanyStory.jsx';
import Approach from './components/Approach.jsx';
import Platform from './components/Platform.jsx';
import InstitutionalFinance from './components/InstitutionalFinance.jsx';
import Contact from './components/Contact.jsx';
import Footer from './components/Footer.jsx';

export default function App() {
  const { i18n, t } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language?.startsWith('en') ? 'en' : 'fr';
    document.title = t('meta.title');
    const description = document.querySelector('meta[name="description"]');
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogDescription = document.querySelector('meta[property="og:description"]');
    description?.setAttribute('content', t('meta.description'));
    ogTitle?.setAttribute('content', t('meta.title'));
    ogDescription?.setAttribute('content', t('meta.description'));
  }, [i18n.language, t]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Nav />
      <main id="top">
        <Hero />
        <CompanyStory />
        <Products />
        <InstitutionalFinance />
        <Approach />
        <Platform />
        <Contact />
      </main>
      <Footer />
    </ThemeProvider>
  );
}
